
export async function loadCourse(courseKey) {
  if (!courseKey) return null;

  try {
    const [
      exercisesMod,
      glossaryMod,
      metadataMod,
      sharedMod,
      aboutMod,
      audiofilesMod,
    ] = await Promise.all([
      import(`./courses/${courseKey}/exercises.js`),
      import(`./courses/${courseKey}/glossary.js`),
      import(`./courses/${courseKey}/metadata.js`),
      import(`./courses/${courseKey}/shared.js`).catch(() => null),     // optional
      import(`./courses/${courseKey}/about.js`).catch(() => null),      // optional
      import(`./courses/${courseKey}/audiofiles.js`).catch(() => null), // optional
    ]);

    const metadata = metadataMod.default ?? metadataMod.METADATA ?? {};

    return {
      exercises: exercisesMod.default ?? exercisesMod.EXERCISES ?? [],
      GlossaryPanel: glossaryMod.default ?? null,
      AboutPanel: aboutMod?.default ?? null,
      metadata,
      shared: sharedMod?.default ?? {}, // ✅ flyt-og-rytme gets it, others get {}
      audioMeta:
        audiofilesMod?.default ??
        audiofilesMod?.INTONATION_AUDIO_META_EN ??
        audiofilesMod?.AUDIO_META ??
        null,

      // ✅ safe default (so SnapsWise can read course.help)
      help: metadata.help ?? { enabled: false, mode: "none" },
    };
  } catch (err) {
    console.warn(`[loadCourse] missing course "${courseKey}"`, err);
    return null;
  }
}